import { createUseStyles } from "react-jss";

export const RequiredSpanStyle = createUseStyles((theme: any) => ({
    required: {
        color: theme.colors.palette.red,
    },
}));
